import getEnv from "@/utils/environment/getEnvironment";
import axios, { AxiosResponse } from "axios";

export function getContracts(): Promise<AxiosResponse> {
  return axios.get(`${getEnv()?.apiBaseUrl}/v1/irma`);
}
